import React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { DateTime } from 'luxon';

import AccountStatus from 'src/components/Account/Status';
import { Loading } from 'src/components/DataState';
import PageHeader from '../Headers/PageHeader';
import { SectionHeader } from '../Headers/elements';
import Inventory from '../Inventory';

import { SALE } from './queries';
import { lotsLabel } from 'src/utils/lotsLabel';
import fonts from 'src/styles/fonts';
import spacing from 'src/styles/spacing';

const Container = styled.div`

`;

const SaleContainer = styled.div`
  padding: ${spacing.elementGap} ${spacing.pageGutter};
`;

const BiddingInfo = styled.div`
  font-size: ${fonts.body.size};
  font-weight: 600;
  margin-bottom: ${spacing.sectionSpacing};
`;

const Sale = () => {
  const { id } = useParams();
  const { data } = useQuery(SALE, { variables: { id } });

  if (!data) { return <Loading />; }

  return (
    <Container>
      <AccountStatus />
      <PageHeader title="Auction" />
      <SaleContainer>
        <SectionHeader>{data.sale.name}</SectionHeader>
        <BiddingInfo>
          LIVE bidding begins{' '}
          {DateTime.fromISO(data.sale.startAt).toFormat('LLL dd, h:mma')}.{' '}
          Pre bidding available now.
        </BiddingInfo>
        <SectionHeader>{lotsLabel(data.sale.visibleSaleAssetsCount)}</SectionHeader>
        <Inventory saleId={data.sale.id} />
      </SaleContainer>
    </Container>
  );
};

export default Sale;
